import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-cbf1927a"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["aria-label"];
const _hoisted_2 = {
  class: "feature-grid"
};
const _hoisted_3 = {
  class: "feature-copy"
};
const _hoisted_4 = {
  class: "feature-art",
  "aria-hidden": "true"
};
const _hoisted_5 = ["src", "alt"];
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import tradeImage from '@/assets/home1/feature-trade.png';
import earnImage from '@/assets/home1/feature-earn.png';
import playImage from '@/assets/home1/feature-play.png';
import buildImage from '@/assets/home1/feature-build.png';
import secureImage from '@/assets/home1/feature-secure.png';
import { getHomePageCopy } from '@/util/homePageCopy';
export default {
  __name: 'HomeFeatureCards',

  setup(__props) {
    const {
      locale
    } = useI18n();
    const copy = computed(() => getHomePageCopy(locale.value).features);
    const features = computed(() => [{
      id: 'trade',
      title: copy.value.trade.title,
      description: copy.value.trade.description,
      image: tradeImage
    }, {
      id: 'earn',
      title: copy.value.earn.title,
      description: copy.value.earn.description,
      image: earnImage
    }, {
      id: 'play',
      title: copy.value.play.title,
      description: copy.value.play.description,
      image: playImage
    }, {
      id: 'build',
      title: copy.value.build.title,
      description: copy.value.build.description,
      image: buildImage
    }, {
      id: 'secure',
      title: copy.value.secure.title,
      description: copy.value.secure.description,
      image: secureImage
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", {
        class: "home-feature-cards",
        "aria-label": _unref(copy).sectionTitle
      }, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(features), feature => {
        return _openBlock(), _createElementBlock("article", {
          key: feature.id,
          class: _normalizeClass(["feature-card", `feature-card--${feature.id}`])
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h3", null, _toDisplayString(feature.title), 1), _createElementVNode("p", null, _toDisplayString(feature.description), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
          src: feature.image,
          alt: feature.title
        }, null, 8, _hoisted_5)])], 2);
      }), 128))])], 8, _hoisted_1);
    };
  }

};